import { datadogRum } from '@datadog/browser-rum';

import packageJson from '../../package.json';
import { AsyncProviderConfig } from 'launchdarkly-react-client-sdk';
import { STORAGE, sessionStorageKeys } from './storage-config';
import { getJourneyName } from 'utils/getSessionStoragePartner';

const { VITE_STAGE } = import.meta.env;

const isLocal = VITE_STAGE === 'local';

export const fallbackFlags = {
  // operational
  'show-application-maintenance-mode': false,
  'show-price-cap': false,
  'show-operational-alert': false,
  'show-cross-sell-offer': false,

  // journeys
  'allow-journey-default': true,
  'allow-journey-voicesales-homemove': true,
  'allow-journey-voicesales-winback': true,
  'allow-journey-voicesales-aquisition': true,
  'allow-journey-nondomestic-transfer': true,
  'allow-journey-move-in': true,
  // release
  'release-solar-registration': false,
  'release-abandoned-cart': false,
  'release-missing-address-lead': false,
  'release-non-domestic-meter-validation': false,
  'release-ev-quote': false,
  'release-ev-quote-voice-sales': false,
  'release-meterpoint-validation-mpxn-improvements': false,
  'release-consumption-update': false,
  'release-caveat-update-on-the-quote-screen': false,
  'release-quoting-ev-for-home-move-journey': false,
  'release-idp-copy': false,
  'release-remove-confirm-cta': false,

  'experiment-direct-debit-new-validation': false,
  'experiment-cross-sales-export-NTB': false,
  'experiment-early-exit-update': false
};

export type LDCustomContext = {
  kind: string;
  user: {
    anonymous: boolean;
    key: string;
  };
  journey?: {
    key: string;
  };
};

export const getLDContext = (): LDCustomContext => {
  let context = {
    kind: 'multi',
    user: {
      anonymous: true,
      key: STORAGE.getItem(sessionStorageKeys.SESSION)
    }
  };

  try {
    const journey = getJourneyName();

    context = {
      ...context,
      ...(journey ? { journey: { key: journey } } : {})
    };
  } catch (e) {
    /* istanbul ignore next -- @preserve */
    console.error(e);
  }

  return context;
};

const ldLocalConfig = {
  clientSideID: 'direct-sales',
  flags: fallbackFlags,
  context: getLDContext(),
  options: {
    streamUrl: 'http://localhost:8765',
    baseUrl: 'http://localhost:8765',
    eventsUrl: 'http://localhost:8765'
  }
};

/* istanbul ignore next -- @preserve */
const launchDarklyConfig: AsyncProviderConfig = {
  clientSideID: import.meta.env.VITE_LAUNCHDARKLY_CLIENT_SIDE_ID,
  flags: fallbackFlags,
  context: getLDContext(),
  options: {
    application: {
      id: `direct-sales-${packageJson.version}`,
      version: packageJson.version
    },
    bootstrap: 'localStorage',
    inspectors: [
      {
        type: 'flag-used',
        name: 'direct-sales-feature-flags',
        method: (flagKey, flagDetail) => {
          datadogRum.addFeatureFlagEvaluation(flagKey, flagDetail.value);
        }
      }
    ]
  }
};

/* istanbul ignore next -- @preserve */
export default isLocal ? ldLocalConfig : launchDarklyConfig;
